import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ImportFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M11.08 3H12.92V11.22L16.52 7.6L17.62 8.68L12 14.3L6.38 8.68L7.48 7.6L11.08 11.22V3ZM5.24 13.86H7.08V17.16H16.92V13.86H18.76V19H5.24V13.86Z" />
    </SvgIcon>
  );
});
